import axios from 'axios';
import { clearToken, getToken, setToken } from './tokenStore';

const API_URL =
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL;

const AUTH_URL = `${API_URL}/auth`;

// The refresh cookie is scoped to /auth, so only those calls carry it.
function isAuthRequest(config) {
    return typeof config.url === 'string' && config.url.startsWith(AUTH_URL);
}

let refreshing = null;

// Single flight: concurrent 401s and page boot share one refresh, because a
// rotating refresh token can be used only once.
export function refreshSession() {
    if (!refreshing) {
        refreshing = axios
            .post(`${AUTH_URL}/admin/refresh`, {})
            .then(response => {
                setToken(response.data.token);
                return response.data;
            })
            .catch(error => {
                clearToken();
                throw error;
            })
            .finally(() => {
                refreshing = null;
            });
    }
    return refreshing;
}

function redirectToLogin() {
    console.error('Redirected to login by 40X response!');
    window.location = '/';
}

axios.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) config.headers.Authorization = token;
        if (isAuthRequest(config)) config.withCredentials = true;
        return config;
    },
    error => Promise.reject(error),
);

axios.interceptors.response.use(
    response => response,
    async error => {
        const { config, response } = error;
        if (!response || !config || isAuthRequest(config))
            return Promise.reject(error);

        if (response.status === 403) {
            redirectToLogin();
            return Promise.reject(error);
        }

        if (response.status !== 401 || config.retried)
            return Promise.reject(error);

        config.retried = true;
        try {
            await refreshSession();
        } catch (refreshError) {
            redirectToLogin();
            return Promise.reject(error);
        }
        return axios(config);
    },
);

export default axios;
